import { Model } from '../model/model.class';

export class Blacklist extends Model {

    public blacklistId: number;

    constructor(
        public blacklistName: String,
        public blacklistMids: number[]
    ) {super(); }
}



// WEBPACK FOOTER //
// ./src/app/model/blacklist.class.ts